import type { SVGProps } from 'react'
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="chevron-right_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#chevron-right_svg__a)">
      <path d="m9.307 9-3.45-3.45L7.05 4.357 11.694 9 7.05 13.643 5.857 12.45z" />
    </g>
  </svg>
)
export default SvgChevronRight
